var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5702,
    cy: 35.5676,
    rx: 34.5755,
    ry: 34.5754,
    fill: "#EE7B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0894 36.1116C47.0827 36.6586 46.6706 37.1056 46.1424 37.1706L45.9957 37.1787L24.3877 36.9117C23.791 36.9043 23.3133 36.4146 23.3206 35.818C23.3274 35.271 23.7394 34.824 24.2676 34.759L24.4144 34.7509L46.0224 35.0179C46.6191 35.0253 47.0968 35.515 47.0894 36.1116Z",
    fill: "#FBFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7807 43.8554C34.1983 44.2816 34.1913 44.9657 33.7651 45.3833C33.3776 45.763 32.777 45.7917 32.3573 45.4736L32.2372 45.3677L23.6291 36.5823C23.2483 36.1936 23.2207 35.5909 23.5414 35.1712L23.648 35.0511L32.4705 26.4796C32.8985 26.0638 33.5825 26.0736 33.9983 26.5016C34.3764 26.8907 34.4026 27.4914 34.0827 27.9098L33.9763 28.0295L25.9325 35.8454L33.7807 43.8554Z",
    fill: "#FBFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.104f890e465eb5469997a7de08fe2274.svg";
export { ForwardRef as ReactComponent };